import React, { Component } from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";

import stl from "./ship.module.scss";

class Ship extends Component {

	state = {
		data: [],
	};

	componentDidMount() {
		const { LayoutActions } = this.props;
		LayoutActions.setModal({
			id: "shipModal",
			target: this,
		});
	}
	
	setData = (data) => {
		let list = [];
		const date = new Date();
		const now = date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate()) + appendZeroValue(date.getHours()) + "" + appendZeroValue(date.getMinutes());
		data.list.forEach((item) => {
			if (parseInt(now) < parseInt(item.depPlandTime.substring(0, 12))) {
				list.push(item);
			}
		});

		data.list = list;
		this.setState({
			data,
		});
	}

	render() {
		const { data } = this.state;

		const contents = (
			<div className={stl.shipWrap}>
				<div className={stl.titleWrap}>
					<span className={stl.posLabel}>{`${data.selectDate} [ ${data.startLocation} ] `}</span>
					<span className="">출발지 조회결과</span>
				</div>

				<div className={stl.infoWrap}>※ 본 정보는 각 해운사의 사정에 따라 변경될 수 있습니다. 최신정보 및 각 해운사별 연락처는 해운사 홈페이지(<a href="http://island.haewoon.co.kr" target="_blank">http://island.haewoon.co.kr</a>)에서 확인하시기 바랍니다.</div>

				<div className={stl.contentsWrap}>
					<table>
						<caption>출발지 조회결과</caption>
						<thead>
							<tr>
								<th>선박명</th>
								<th>출발지</th>
								<th>도착지</th>
								<th>출발예정시간</th>
								<th>운임(원)</th>
							</tr>
						</thead>
						<tbody>
							{ data.list !== undefined && data.list.length > 0 &&
								data.list.map((item, idx) => {
									const time = item.depPlandTime.substring(8, 10) + ':'
												+ item.depPlandTime.substring(10, 12);
									const charge = item.charge !== null ? item.charge.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-';
									return (
										<tr key={idx}>
											<td>{item.vihicleNm}</td>
											<td>{item.depPlaceNm}</td>
											<td>{item.arrPlaceNm}</td>
											<td>{time}</td>
											<td>{charge}</td>
										</tr>
									);
								})
							}
							{
								data.list !== undefined && data.list.length === 0 &&
								<tr>
									<td colSpan="5">조회하신 정보가 존재하지 않습니다.</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		);

		return (
			<div>
				<SisModal id={this.props.id} className={stl.shipModal} title="해운 운행시간 조회" draggable contents={contents} />
			</div>
		);
	}
}


function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}

export default compose(
	withRouter,
	connect(
		(state) => ({
			layout: state.layout,
			sis: state.sisMap,
		}),
		(dispatch) => ({
			SisMapActions: bindActionCreators(sisMapActions, dispatch),
			LayoutActions: bindActionCreators(layoutActions, dispatch),
		})
	)
)(Ship);

// export default Ship;